import AccountMarketingMaterialShutterbugFlyerTemplate from './AccountMarketingMaterialShutterbugFlyerTemplate';

export default AccountMarketingMaterialShutterbugFlyerTemplate;
